import styled from 'styled-components';
import { IFrame } from './interface';

const base = styled.div<IFrame>`
  display: ${(props) => (props.isActive === true ? 'grid' : 'none')};
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 16rem;
  grid-template-areas: 'slbPaid lastTwelveMonths';
  column-gap: 1rem;
  row-gap: 1rem;
  width: 100%;
  margin-top: 0.5rem;

  @media (min-width: ${(props) => props.theme.mediaQuery.desktop}) {
    grid-template-columns: 20.8rem 42.6rem;
    grid-template-areas: 'slbPaid  lastTwelveMonths  ';
  }
`;

const Frame = {
  Base: base,
};

export default Frame;
